import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Validators } from '@angular/forms';

import { BaseCrudModalComponent } from 'projects/ProjetoBaseAngular/app/base-crud-modal.component';
import { GrupoProcedimentoService } from '../../domain/services';
import { GrupoProcedimentoModel } from '../../domain/models';

@Component({
  selector: 'app-grupo-procedimento-modal',
  templateUrl: './grupo-procedimento-modal.component.html'
})
export class GrupoProcedimentoModalComponent extends BaseCrudModalComponent<GrupoProcedimentoModel> implements OnInit {
  @ViewChild('modal') modal: ModalDirective;

  constructor(
    injector: Injector,
    service: GrupoProcedimentoService
  ) {
    super(injector, service);
  }

  protected initializeForm(model: GrupoProcedimentoModel) {
    this.form = this.formBuilder.group({
      id: model.id,
      dataInclusao: [model.dataInclusao, Validators.required],
      dataAlteracao: model.dataAlteracao,      
      
      nome: [model.nome, [        
        Validators.required, Validators.maxLength(50)        
      ]],
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
